module.exports = __webpack_public_path__ + "static/img/5752_phase_function_Paper_PointsHejduk_Prediction.9440944.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5752_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /VwP
// module chunks = 0